import styled from "styled-components";

export const IntegrationTabContainer = styled.div`
    width: 100%;
    margin: 0;
    background-color: #fff;
    border-radius: 10px;
    padding: 20px;
    min-height: 15vh;
    display: flex;
    align-items: center;
    justify-content: flex-start;
`;

export const IntegrationsGrid = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 0;
    gap: 48px;
    flex-wrap: wrap;

    @media (max-width: 768px) {
        grid-template-columns: repeat(auto-fit, 160px);
        gap: 10px;
        flex-direction: column;
    }

    @media (max-width: 480px) {
        grid-template-columns: repeat(auto-fit, 140px);
        gap: 8px;
    }

    @media (max-width: 320px) {
        grid-template-columns: repeat(auto-fit, 120px);
        gap: 6px;
    }
`;

export const IntegrationRow = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    font-size: 14px;
`;

export const IntegrationText = styled.div`
    font-size: 16px;
    font-weight: 600;
    color: ${props => props.platformColor || "#aef001"};
`;
